const setTextForBooleanOrNull = (value) => {
  return value === null || value === undefined ? "" : value ? "Da" : "Ne";
};

export default setTextForBooleanOrNull;
